import request from '@api/request';
import { catalogGet } from '@utilities/http/apiQueryHeaders';
import { builder } from '@utilities/queryBuilder';

export type ProductPdpDose = {
  dose: string;
  irc: string;
  imageLink?: string | null;
};

export type ProductPdpSlang = {
  name: string;
};

export type ProductPdpBySearchResponse = {
  drugDoses: ProductPdpDose[];
  productName: string;
  slangs?: ProductPdpSlang[] | null;
  warning?: string | null;
  adverseEffects?: string | null;
  medicalUses?: string | null;
  imageLink?: string | null;
  isOtc: boolean;
  unit?: string | null;
  recommendations?: string | null;
  categoryName?: string | null;
  brandName?: string | null;
  discountPercentage?: number | null;
  price?: number | null;
  discount?: number | null;
};

export const getProducts = async () =>
  await request.get('/Product/management/CategoryProducts', null, {
    params: {
      categoryName: 'شیاف استامینوفن',
      pageNumber: 1,
      pageSize: 5,
    },
  });

export const GetCategoryLevel2Products = async (parentCode: string) =>
  await request.get(
    `/Product/management/GetCategoryLevel3Products?categoryCodeLevel2=${parentCode}`,
  );

export const GetProductsShapes = async (categoryCodeLevel2: string) =>
  await request.get(
    `/Product/management/GetShape?categoryCodeLevel2=${categoryCodeLevel2}`,
  );

export const GetFilteredProductsByShapes = async (
  categoryCode: string,
  shapeCode: number,
) =>
  await request.get(
    `/Product/management/FilteProductByShape?categoryCodeLevel2=${categoryCode}&shapeCode=${shapeCode}`,
  );

export type ProductPdpQuery = {
  irc?: string;
  brandName?: string;
  categoryCodeLevel3?: string;
};

export const GetProductsFromSearch = async (query: ProductPdpQuery) =>
  catalogGet(`Product/management/PDPBySearch`, {
    ...query,
    irc: query.irc,
  });

export const GetShoppingPDPBySearch = async (
  query: ProductPdpQuery,
): Promise<ProductPdpBySearchResponse> =>
  request.get<ProductPdpBySearchResponse>(
    `Shop/management/ShoppingPDPBySearch`,
    null,
    {
      params: {
        brandName: query.brandName,
        categoryCodeLevel3: query.categoryCodeLevel3,
        irc: query.irc,
      },
    },
  );

export const GetOtcMedicineProducts = async (
  query: Record<string, unknown> = {},
) => catalogGet(`/Product/management/OtcProducts`, query);

export const GetOtcProductsShapes = async (categoryCodeLevel1: string) => {
  const params = builder({ categoryCodeLevel1 });
  return request.get(`/Product/management/Shapes${params}`);
};
